// import React from "react";

// const InventoryTable = ({
//   title,
//   items = [],
//   selectedIds = [],
//   selectedQuantities = {},
//   isLoading = false,
//   onSelectAll,
//   onSelectOne,
//   onQuantityChange,
//   onScroll,
// }) => {
//   return (
//     <>
//       <h6 className="fw-bold">{title}</h6>
//       <div
//         className="mt-2 border p-3 rounded"
//         style={{ height: "400px", overflowY: "auto", borderRadius: "6px" }}
//         onScroll={onScroll}
//       >
//         <table className="table mb-0 text-center align-middle">
//           <thead>
//             <tr>
//               <th
//                 style={{
//                   backgroundColor: "#82c14a",
//                   color: "white",
//                   borderRadius: "6px 0 0 0",
//                 }}
//               >
//                 <input
//                   type="checkbox"
//                   onChange={onSelectAll}
//                   checked={
//                     items.length > 0 && selectedIds.length === items.length
//                   }
//                 />
//               </th>
//               <th style={{ backgroundColor: "#82c14a", color: "white" }}>
//                 SKU
//               </th>
//               <th style={{ backgroundColor: "#82c14a", color: "white" }}>
//                 Item Name
//               </th>
//               <th
//                 style={{
//                   backgroundColor: "#82c14a",
//                   color: "white",
//                   borderRadius: "0 6px 0 0",
//                 }}
//               >
//                 Quantity
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {items.map((item, idx) => (
//               <tr key={item.id || idx}>
//                 <td>
//                   <input
//                     type="checkbox"
//                     checked={selectedIds.includes(item.id)}
//                     onChange={(e) => onSelectOne(e, item.id)}
//                   />
//                 </td>
//                 <td>{item.sku}</td>
//                 <td>{item.itemName}</td>
//                 <td>
//                   <input
//                     type="number"
//                     min="1"
//                     value={selectedQuantities[item.id]?.quantity || ""}
//                     onChange={(e) => onQuantityChange(e, item)}
//                     className="form-control form-control-sm text-center border-success"
//                     style={{ width: "60px", margin: "0 auto" }}
//                   />
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {isLoading && (
//           <div className="text-center my-3">
//             <div className="spinner-border text-success" role="status" />
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export const QuantityBulkInput = ({
//   quantity = "",
//   isDisabled = false,
//   onChange,
//   onUpdate,
// }) => {
//   return (
//     <div className="d-flex align-items-center gap-2 mb-3">
//       <input
//         type="number"
//         className="form-control form-control-md w-100"
//         placeholder="Quantity"
//         value={quantity}
//         onChange={onChange}
//         disabled={isDisabled}
//         style={{ width: "200px" }}
//       />
//       <button
//         className="btn"
//         style={{ backgroundColor: "#82c14a", color: "white" }}
//         disabled={isDisabled || quantity.trim() === ""}
//         onClick={onUpdate}
//       >
//         Update
//       </button>
//     </div>
//   );
// };

// export default InventoryTable;

import React from "react";

export const QuantityBulkInput = ({
  quantity = "",
  isDisabled = false,
  onChange,
  onUpdate,
}) => {
  return (
    <div className="d-flex align-items-center gap-2 mb-3">
      <input
        type="number"
        className="form-control form-control-md w-100"
        placeholder="Quantity"
        value={quantity}
        onChange={onChange}
        disabled={isDisabled}
        style={{ width: "200px" }}
      />
      <button
        className="btn"
        style={{ backgroundColor: "#82c14a", color: "white" }}
        disabled={isDisabled || quantity.trim() === ""}
        onClick={onUpdate}
      >
        Update
      </button>
    </div>
  );
};

const InventoryTable = ({
  title,
  items = [],
  selectedIds = [],
  selectedQuantities = {},
  isLoading = false,
  onSelectAll,
  onSelectOne,
  onQuantityChange,
  onScroll,
  searchKeyword = "",
  onSearchChange,
}) => {
  const filteredItems = items.filter((item) =>
    item.itemName?.toLowerCase().includes(searchKeyword.toLowerCase())
  );

  console.log("ddd", filteredItems);

  return (
    <div>
      <h6 className="fw-bold">{title}</h6>
      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search item name..."
          value={searchKeyword}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      <div
        className="border p-3 rounded"
        style={{ height: "400px", overflowY: "auto", borderRadius: "6px" }}
        onScroll={onScroll}
      >
        <table className="table mb-0 text-center align-middle">
          <thead>
            <tr>
              <th
                style={{
                  backgroundColor: "#82c14a",
                  color: "white",
                  borderRadius: "6px 0 0 0",
                }}
              >
                <input
                  type="checkbox"
                  onChange={onSelectAll}
                  checked={
                    filteredItems.length > 0 &&
                    selectedIds.length === filteredItems.length
                  }
                />
              </th>
              <th style={{ backgroundColor: "#82c14a", color: "white" }}>
                SKU
              </th>
              <th style={{ backgroundColor: "#82c14a", color: "white" }}>
                Item Name
              </th>
              <th style={{ backgroundColor: "#82c14a", color: "white" }}>
                UOM
              </th>
              <th
                style={{
                  backgroundColor: "#82c14a",
                  color: "white",
                  borderRadius: "0 6px 0 0",
                }}
              >
                Quantity
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.length > 0 ? (
              filteredItems.map((item, idx) => (
                <tr key={item.id || idx}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(item.id)}
                      onChange={(e) => onSelectOne(e, item.id)}
                    />
                  </td>
                  <td>{item.sku}</td>
                  <td>{item.itemName}</td>
                  <td>{item.uom?.name}</td>
                  <td>
                    <input
                      type="number"
                      min="0"
                      step="any" // allow 1.5, 0.25, etc.
                      inputMode="decimal" // better mobile keyboard
                      value={selectedQuantities[item.id]?.quantity || ""}
                      onChange={(e) => onQuantityChange(e, item)}
                      className="form-control form-control-sm text-center border-success"
                      style={{ width: "120px", margin: "0 auto" }}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="text-center py-4 text-muted">
                  No items found.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {isLoading && (
          <div className="text-center my-3">
            <div className="spinner-border text-success" role="status" />
          </div>
        )}
      </div>
    </div>
  );
};

export default InventoryTable;
